<template>
    <div class="app-main goods-list">

        
        <div class="top-bar">
            <el-input placeholder="输入商品名称或者条形码" v-model="value" @change="search()" style="width:210px;margin-right:20px;" clearable>
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
        </div>
        <!-- 商品列表 -->
        <el-card shadow="hover">
            <el-table ref="multipleTable" :data="tableData"  height="600" style="width: 100%">
                <el-table-column label="商品图片" align="center" width="150">
                    <template slot-scope="scope">
                        <m-img v-if="scope.row.image_url" :src="scope.row.image_url" />
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="商品名称"  align="center"   show-overflow-tooltip></el-table-column>
                <!-- <el-table-column prop="name"  label="商品类型" align="center" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.goods_type == 2">食品类型</span>
                        <span v-else-if="scope.row.goods_type == 3">服务类型</span>
                        <span v-else>普通商品</span>
                    </template>
                </el-table-column> -->
                <el-table-column prop="status" align="center" label="商品状态">
                    <template slot-scope="scope">
                        <el-link type="danger"  v-if="scope.row.status == 2">已下架</el-link>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="updated_at"  align="center" label="操作时间" ></el-table-column> -->
                <el-table-column prop="visits"      align="center" label="浏览量" ></el-table-column>
                <el-table-column  prop="sales_volume" align="center" label="商品销量"  sortable>
                    <!-- <template slot-scope="scope">
                        <el-input v-model="scope.row.sales_volume" @change="handleSales(scope.row)" size="mini" style="width:80px" readonly></el-input>
                    </template> -->
                </el-table-column>
                <el-table-column prop="totalMoney"  align="center" label="商品操作" width="200">
                    <template slot-scope="scope">
                        <div class="table-btns">
                            <el-button v-if="scope.row.status == 2 || scope.row.status == 4" @click="goodsEdit(scope.row, 1)" type="success" plain size="mini">上架商品</el-button>
                            <el-button v-if="scope.row.status != 1" @click="$router.push({path: `/goods/mooby/edit/${scope.row.id}`})" type="primary" plain size="mini" >修改商品</el-button>
                            <el-button v-if="scope.row.status == 2" @click="goodsEdit(scope.row, 5)" type="danger" plain size="mini">加入回收站</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background @current-change="reloadData" :current-page.sync="page" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="20" ></el-pagination>
        </el-card>



    </div>
</template>



<script>
/* eslint-disable */
import { goods_list, goods_status } from '@/api/goods.js'

import MImg   from './../../../components/Image'

export default {
    components: { MImg },
    data() {
        return {
            value:'',
            tableData:[],
            table_load:false,
            checkData:[],
            total:0,
            page:1,
            goods_modal:false,
            sku:[],
            goodsId:'',                   //商品ID


            sku_title: '',
            sku_modal: false,
        }
    },
    methods: {

        search() {
            this.page = 1
            this.getData()
        },
        getData(){
            this.tableData = [];
            let params = {
                page:this.page,
                status:2,
            }
            if(this.value != ""){
                params.search = this.value;
            }
            goods_list(params).then(res => {
                if(res){
                    // 通过日期排序 
                    // res.data.data.sort((a,b)=>{
                    //     if (a.updated_at < b.updated_at ) {
                    //         return 1;
                    //     } else if (a.updated_at > b.updated_at ) {
                    //         return -1;
                    //     } else {
                    //         if (a.updated_at < b.updated_at ) {
                    //             return -1;
                    //         } else if (a.updated_at > b.updated_at ) {
                    //             return 1;
                    //         }
                    //         return 0;
                    //     }
                    // })
                    this.tableData = res.data.data
                    this.total = res.data.total
                }else{
                    this.tableData = [];
                    // this.$message.error('Error')
                }
            })
        },
        reloadData(page){
            this.page = page;
            this.getData();
            this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
        },
        goodsEdit(row,flag){
            let params = {
                status:flag
            }
            goods_status(row.id,params).then(res => {
                if(res){
                    this.$message({message:res.msg,type:'success'})
                    this.getData()
                }else{
                    this.$message.error(res.msg)
                }
            }).catch(err => {
                this.table_load = false;
                console.log(err)
            })
        },
    },
    created(){
        this.getData();
    },
    activated() {
        this.getData()
    },
}
</script>

<style lang="less" scoped>
.table-btns {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .el-button {
            margin-bottom: 5px;
        }
        .el-button+.el-button {
            margin-left: 0;
        }
    }
</style>
